"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _containers = require("../containers");

var _cards = require("../../styles/cards");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default(props) {
  var _props$cardImageProps = props.cardImageProps,
      cardImageProps = _props$cardImageProps === void 0 ? {} : _props$cardImageProps,
      _props$rightContentPr = props.rightContentProps,
      rightContentProps = _props$rightContentPr === void 0 ? {} : _props$rightContentPr,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? "0.5rem" : _props$padding,
      isDisabled = props.isDisabled;
  return /*#__PURE__*/_react["default"].createElement(_containers.FlexColumn, {
    height: props.height || "auto",
    width: props.width,
    padding: padding
  }, /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, {
    opacity: isDisabled ? "50%" : "100%"
  }, /*#__PURE__*/_react["default"].createElement(_containers.Container, {
    boxSizing: "border-box",
    width: cardImageProps.width || "15%",
    padding: cardImageProps.padding || "0.5rem"
  }, props.cardImgSrc && /*#__PURE__*/_react["default"].createElement(_cards.CardImage, {
    src: props.cardImgSrc
  })), /*#__PURE__*/_react["default"].createElement(_containers.Container, {
    flex: 1
  }, props.children), props.rightContent && /*#__PURE__*/_react["default"].createElement(_containers.Container, {
    boxSizing: "border-box",
    width: rightContentProps.width,
    padding: rightContentProps.padding || "0.5rem"
  }, props.rightContent)), props.disclaimer && /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, {
    padding: padding,
    position: "relative"
  }, props.disclaimer));
};

exports["default"] = _default;
module.exports = exports["default"];